( function () {

    "use strict";

    var $body = $('body');

    // Banner Slider
    if ( $.fn.slick ) {

        $( '.mr-banner-slider' ).slick({
            infinite: true,
            //autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<div class="slick-prev slick-btn slick-left"></div>',
            nextArrow: '<div class="slick-next slick-btn slick-right"></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    // Collection Slider
    if ( $.fn.slick ) {

        $( '.collection-slider' ).slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="slick-prev slick-btn slick-left"></div>',
            nextArrow: '<div class="slick-next slick-btn slick-right"></div>',
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    // Newsletter
    if(Cookies.get('newsletters') == null) {
        $('#mr-newsletter').show();
    }
    // Newsletter
    $body.on( 'click', '.newsletter-close', function (e) {
        e.preventDefault();
        Cookies.set('newsletters', 'value', { expires: 3 });
        $('#mr-newsletter').hide();
    });
    // Announcement Bar
    if(Cookies.get('announcement_bar') == null) {
        $('.announcement-bar').show();
    }

    $body.on( 'click', '.size-guide', function (e) {
        $('.size-guide-container').toggleClass('has-active');
    });
    $body.on( 'click', '.guide-click', function (e) {
        e.preventDefault();
        var ID = $(this).attr('href');
        $('.guide-click').removeClass('has-active');
        $(this).addClass('has-active');
        console.log( ID );

        $('.guide-content').hide();

        $(this).parents( '.grid' ).find('#'+ID).show();
    });
    $body.on( 'click', '.announcement-close', function (e) {
        e.preventDefault();
        Cookies.set('announcement_bar', 'value', { expires: 7 });
        $('.announcement-bar').hide();
    });
    $body.on( 'click', '.dismiss', function (e) {
        e.preventDefault();
        $('.success-message').hide();
    });
    // Add to Cart
    // $body.on( 'click', '.two-product-image .themetim-add-to-cart', function(e) {
    //     e.preventDefault();
    //     var productElement = $(this);
    //     //SKL
    //     $('.themetim-add-to-cart').removeClass('has-active');
    //     $(this).addClass('has-active');
    //     var id = productElement.attr('data-variant-id');
    //     var quantity = parseInt(productElement.find('.themetim-product-quantity').val());
    //     if (!quantity) quantity = 1;
    //     $.ajax({
    //         type: "post",
    //         url: "/cart/add.js",
    //         data: 'quantity=' + quantity + '&id=' + id,
    //         dataType: 'json',
    //         beforeSend: function() {
    //             //$('.success-message').remove();
    //         },
    //         success: function(msg) {
    //             console.log(msg);
    //             var html = '<div class="successaddmessage">\n' +
    //                 '                        <div class="header modal-header">Item has been added to your cart<a href="javascript:void(0);" class="npopup-btn-close dismiss" role="button" aria-label="Close popup"></a></div>\n' +
    //                 '                        <div class="body modal-body">\n' +
    //                 '                        <div class="image">\n' +
    //                 '                        <img src="'+msg.image+'">\n' +
    //                 '                        </div>\n' +
    //                 '                        <div class="description"><b>1</b> x '+msg.title+'.</div>\n' +
    //                 '                        <div class="successaddmessageclear"></div></div>\n' +
    //                 '                        <div class="footer"><div class="right"><a href="/cart" class="btn btn-default npopup-view " title="View Cart">View My Cart</a><a href="/checkout" class="btn btn-success calltoaction npopup-checkout" title="Checkout">Checkout Now</a></div></div>\n' +
    //                 '                        <div class="successaddmessageclear"></div></div>';
    //             $('.success-message .npopup').html(html).show();
    //             $('.success-message').show();
    //         },
    //         error: function(xhr, text) {
    //             alert($.parseJSON(xhr.responseText).description);
    //         }
    //     });
    // });



})();